import { Header } from '../../components';
import {
  AlturaManual,
  VerticalManual,
  HorizontalManual,
  DiagonalManual,
  PonteManual,
  ReguaManual,
} from '../../assets';
import * as S from './styles';

export default function Manual() {
  return (
    <>
      <Header />
      <S.Container>
        <S.Card>
          <S.CardImage
            src={AlturaManual}
            alt="Óculos com seta indicando altura"
            loading="eager"
          />
          <S.CardTitle>Altura</S.CardTitle>
          <S.CardText>
            Medida do centro ótico para parte inferior do aro.
            <br />
            <br />
            Em caso de multifocal: do centro da pupila para a parte inferior do
            aro.
            <br />
            Em caso de bifocal: da pálpebra inferior para a parte inferior do
            aro.
          </S.CardText>
        </S.Card>
        <S.Card>
          <S.CardImage
            src={VerticalManual}
            alt="Óculos com seta indicando altura"
            loading="eager"
          />
          <S.CardTitle>Vertical</S.CardTitle>
          <S.CardText>Medida vertical do aro.</S.CardText>
        </S.Card>
        <S.Card>
          <S.CardImage
            src={HorizontalManual}
            alt="Óculos com seta indicando altura"
            loading="lazy"
          />
          <S.CardTitle>Horizontal</S.CardTitle>
          <S.CardText>
            Medida horizontal do aro (medir sempre na linha do centro ótico).
          </S.CardText>
        </S.Card>
        <S.Card>
          <S.CardImage
            src={DiagonalManual}
            alt="Óculos com seta indicando altura"
            loading="lazy"
          />
          <S.CardTitle>Diagonal</S.CardTitle>
          <S.CardText>Maior medida possível do aro</S.CardText>
        </S.Card>
        <S.Card>
          <S.CardImage
            src={PonteManual}
            alt="Óculos com seta indicando altura"
            loading="lazy"
          />
          <S.CardTitle>Ponte</S.CardTitle>
          <S.CardText>
            Distância entre os dois aros (medir sempre na linha do centro
            ótico).
          </S.CardText>
        </S.Card>
        <S.Card>
          <S.CardImage
            src={ReguaManual}
            alt="Óculos com seta indicando altura"
            loading="lazy"
          />
        </S.Card>
      </S.Container>
    </>
  );
}
